import { Breadcrumb, Button, FloatingLabel, Form, Modal } from "react-bootstrap";
import LoadingComponent from "../../widgets/LoadingComponent";
import { FaCheck, FaCog, FaEdit, FaPlus, FaTrash } from "react-icons/fa";
import { useEffect, useState } from "react";
import { getData, postData } from "../../api/ApiRest";
import { FaXmark } from "react-icons/fa6";
import auditoriaSet from "../../widgets/Auditoria";
import { usePermission } from "../../helper/authHelper";
import { Grid, TextField, Typography, Card, CardContent } from "@mui/material";

function Smtp() {
    const [loading, setLoading] = useState(false);
    const [gestionModal, setGestionModal] = useState({ ModalVisible: false, Titulo: '', correosmtpid: '' });
    const [infoSmtp, setInfoSmtp] = useState({
        codigo: '', descripcion: '', activo: '', usuario: '', clave: '', puerto: '', smtp: ''
    });
    const [infoSmtpAnterior, setInfoSmtpAnterior] = useState({
        codigo: '', descripcion: '', activo: '', usuario: '', clave: '', puerto: '', smtp: ''
    });
    const [configSmtp, setConfigSmtp] = useState([]);


    ///State para la configuración de los planes y certificados a partir de un SMTP
    const [envioSmtp, setEnvioSmtp] = useState({ ModalVisible: false, Titulo: '' });
    const [datosEnvioConfig, setDatosEnvioConfig] = useState({});
    const [plantilla, setPlantilla] = useState([]);
    const [datosEnvioAntes, setDatosEnvioAntes] = useState({});

    const { GestionConfigEnvios } = usePermission([
        "GestionConfigEnvios"
    ]);

    useEffect(() => {
        getSmtp();

        if (envioSmtp.ModalVisible) {
            getPlantillas();
            getEnvioConfig();
        }

    }, [envioSmtp.ModalVisible])

    ///Función para obtener los smtp previamente creados
    const getSmtp = () => {
        setLoading(true);

        getData('api/Configuracion/AdminEnvio/getSmtp').then(response => {
            if (response.status) {
                setConfigSmtp(response.configSmtp);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función para guardar el create o el edit de un smtp
    const guardarSmtp = () => {
        setLoading(true);

        postData('api/Configuracion/AdminEnvio/guardarSmtp', {
            smtpid: gestionModal.correosmtpid || ''
        }, infoSmtp).then(response => {
            if (response.status && gestionModal.correosmtpid === '') {
                ///Procedemos a guardar la auditoría correspondiente
                auditoriaSet(infoSmtp, {}, 'C', 'Administración', '', 'ConfigSmtp');

                setConfigSmtp(prev => [
                    ...prev,
                    {
                        correosmtpid: response.configSmtp[0].correosmtpid,
                        codigo: response.configSmtp[0].codigo,
                        descripcion: response.configSmtp[0].descripcion,
                        activo: response.configSmtp[0].activo
                    }
                ])
            } else {
                auditoriaSet(infoSmtpAnterior, infoSmtp, 'A', 'Administración', '', 'ConfigSmtp');

                getSmtp();
            }

            ///Seteamos state para evitar traer la info cuando aperturo el modal
            setInfoSmtp({
                codigo: '', descripcion: '', activo: '', usuario: '', clave: '', puerto: '', smtp: ''
            });

            setInfoSmtpAnterior({
                codigo: '', descripcion: '', activo: '', usuario: '', clave: '', puerto: '', smtp: ''
            });

            setGestionModal({
                ModalVisible: false, Titulo: '', correosmtpid: ''
            });

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    //Función para eliminar un regitrso smtp
    const eliminarSmtp = (id) => {
        setLoading(true);

        getData('api/Configuracion/AdminEnvio/eliminarSmtp', {
            smtpid: id
        }).then(response => {
            if (response.status) {
                ///Procedemos a guardar la auditoría correspondiente
                auditoriaSet(response.configSmtp, {}, 'E', 'Administración', '', 'ConfigSmtp');

                getSmtp();
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ////Función para traer un smtp en especifico
    const getSmtpEdit = (id) => {
        setLoading(true);

        getData('api/Configuracion/AdminEnvio/getSmtpEdit', {
            smtpid: id
        }).then(response => {
            if (response.status) {
                setInfoSmtp({
                    codigo: response.configSmtp.codigo,
                    clave: response.configSmtp.clave,
                    activo: response.configSmtp.activo,
                    descripcion: response.configSmtp.descripcion,
                    puerto: response.configSmtp.puerto,
                    smtp: response.configSmtp.smtp,
                    usuario: response.configSmtp.usuario,
                    correosmtpid: response.configSmtp.correosmtpid
                });

                setInfoSmtpAnterior({
                    codigo: response.configSmtp.codigo,
                    clave: response.configSmtp.clave,
                    activo: response.configSmtp.activo,
                    descripcion: response.configSmtp.descripcion,
                    puerto: response.configSmtp.puerto,
                    smtp: response.configSmtp.smtp,
                    usuario: response.configSmtp.usuario,
                    correosmtpid: response.configSmtp.correosmtpid
                });
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función para obtener las plantillas para la configuración de envió
    const getPlantillas = () => {
        setLoading(true);

        getData('api/Configuracion/AdminEnvio/GetPlantillaCorreos').then(response => {
            if (response.status) {
                setPlantilla(response.plantillas);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        });
    }

    //Función para visualizar la info previa de la configuración de envió
    const getEnvioConfig = () => {
        setLoading(true);

        getData('api/Configuracion/AdminEnvio/getConfigEnvio').then(response => {
            if (response.status) {
                setDatosEnvioConfig(response.objectoConfig);
                setDatosEnvioAntes(response.objectoConfig);
            }

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    ///Función para guardar la configuración de envió
    const guardarConfigEnvio = () => {
        if (!GestionConfigEnvios) {
            alert('No tienes permiso para esta acción');
            return;
        }

        setLoading(true);

        postData('api/Configuracion/AdminEnvio/guardarConfigEnvio', {
            correosmtpconfigid: datosEnvioConfig.correosmtpconfigd || ''
        }, datosEnvioConfig).then(response => {
            if (response.status)
                alert('Información guardada correctamente');

            ///Procedemos a guardar la auditoria
            auditoriaSet(datosEnvioAntes, datosEnvioConfig, 'A', 'Administración', '', 'configEnvio');

            setLoading(false);
        }, error => {
            console.log(error);
            setLoading(false);
        })
    }

    return <div className='BodyComponent'>
        <Breadcrumb color='black'>
            <Breadcrumb.Item >Administración</Breadcrumb.Item>
            <Breadcrumb.Item active={true}>SMTP</Breadcrumb.Item>
        </Breadcrumb>

        <div className="row">
            <div className="col-md-1">
                <Button variant='success'
                    className='mb-2' onClick={() => setGestionModal({ ModalVisible: true, Titulo: 'Nuevo SMTP', correosmtpid: '' })}>
                    <FaPlus size={'1rem'} />
                </Button>
            </div>
            <div className="col-md-1">
                <Button variant='dark'
                    className='mb-2' onClick={() => setEnvioSmtp({ ModalVisible: true, Titulo: 'Configuración envios' })}>
                    <FaCog size={'1rem'} />
                </Button>
            </div>
        </div>

        {<LoadingComponent Loading={loading} />}
        <div className='table-responsive mt-2'>
            <table className='table table-sm table-bordered table-hover'>
                <thead>
                    <tr>
                        <th></th>
                        <th>
                            Código
                        </th>
                        <th>
                            Descripción
                        </th>
                        <th>
                            Activo
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {configSmtp.map((item, index) => (
                        <tr key={item.correosmtpid}>
                            <td className='text-center'>
                                <Button type='button' variant='primary' size='sm' title='Editar smtp' className="me-2"
                                    onClick={() => {
                                        setGestionModal({ ModalVisible: true, Titulo: 'Editar smtp', correosmtpid: item.correosmtpid });

                                        getSmtpEdit(item.correosmtpid);
                                    }}>
                                    <FaEdit size={'1rem'} />
                                </Button>
                                <Button type='button' variant='danger' size='sm' title='Eliminar smtp'
                                    onClick={() => eliminarSmtp(item.correosmtpid)}>
                                    <FaTrash size={'1rem'} />
                                </Button>
                            </td>
                            <td className="text-center">
                                {item.codigo}
                            </td>
                            <td className='text-center'>
                                {item.descripcion}
                            </td>
                            <td className='text-center'>
                                {item.activo ? <FaCheck size={'1rem'} /> : <FaXmark size={'1rem'} />}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>

        <Modal
            show={gestionModal.ModalVisible}
            onHide={() => {
                setInfoSmtp({
                    codigo: '', descripcion: '', activo: '', usuario: '', clave: '', puerto: '', smtp: ''
                });

                setGestionModal({
                    ModalVisible: false, Titulo: '', correosmtpid: ''
                });
            }}
            backdrop="static"
            keyboard={false}
            size="xl"
        >
            <Modal.Header closeButton>
                <Modal.Title>{gestionModal.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <div className='row'>
                    <div className='col-md-2'>
                        <FloatingLabel controlId="codigoNewInput" label="Código">
                            <Form.Control
                                as="input"
                                type='text'
                                placeholder="Código"
                                rows={1}
                                autoComplete='off'
                                value={infoSmtp.codigo}
                                onChange={event => setInfoSmtp({ ...infoSmtp, codigo: event.target.value })}
                            />
                        </FloatingLabel>
                    </div>
                    <div className='col-md-4'>
                        <FloatingLabel controlId="descripcionNewInput" label="Descripción">
                            <Form.Control
                                as="input"
                                type='text'
                                placeholder="Descripción"
                                rows={1}
                                autoComplete='off'
                                value={infoSmtp.descripcion}
                                onChange={event => setInfoSmtp({ ...infoSmtp, descripcion: event.target.value })}
                            />
                        </FloatingLabel>
                    </div>
                    <div className='col-md-1'>
                        <label>Activo</label>
                        <Form.Check
                            style={{ textAlign: 'center', justifyContent: 'center' }}
                            required
                            checked={infoSmtp.activo}
                            onChange={event => setInfoSmtp({ ...infoSmtp, activo: event.target.checked })}
                        />
                    </div>
                    <div className='col-md-5'>
                        <FloatingLabel controlId="smtpNewInput" label="SMTP">
                            <Form.Control
                                as="input"
                                type='text'
                                placeholder="SMTP"
                                rows={1}
                                autoComplete='off'
                                value={infoSmtp.smtp}
                                onChange={event => setInfoSmtp({ ...infoSmtp, smtp: event.target.value })}
                            />
                        </FloatingLabel>
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className='col-md-3'>
                        <FloatingLabel controlId="usuarioNewInput" label="Usuario">
                            <Form.Control
                                as="input"
                                type='text'
                                placeholder="Usuario"
                                rows={1}
                                autoComplete='off'
                                value={infoSmtp.usuario}
                                onChange={event => setInfoSmtp({ ...infoSmtp, usuario: event.target.value })}
                            />
                        </FloatingLabel>
                    </div>
                    <div className='col-md-4'>
                        <FloatingLabel controlId="claveNewInput" label="Clave">
                            <Form.Control
                                as="input"
                                type='text'
                                placeholder="Clave"
                                rows={1}
                                autoComplete='off'
                                value={infoSmtp.clave}
                                onChange={event => setInfoSmtp({ ...infoSmtp, clave: event.target.value })}
                            />
                        </FloatingLabel>
                    </div>
                    <div className='col-md-2'>
                        <FloatingLabel controlId="puertoNewInput" label="Puerto">
                            <Form.Control
                                as="input"
                                type='number'
                                rows={1}
                                autoComplete='off'
                                value={infoSmtp.puerto}
                                onChange={event => setInfoSmtp({ ...infoSmtp, puerto: event.target.value })}
                            />
                        </FloatingLabel>
                    </div>
                    <div className='col-md-1'>
                        <Button variant="success" size='sm' type='button' onClick={guardarSmtp}>Guardar</Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>


        <Modal
            show={envioSmtp.ModalVisible}
            onHide={() => {
                setEnvioSmtp({ ModalVisible: false, Titulo: '' });
            }}
            backdrop="static"
            keyboard={false}
            size="xl"
        >
            <Modal.Header closeButton>
                <Modal.Title>{envioSmtp.Titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <div className='row'>
                    <div className='col-md-3'>
                        <FloatingLabel
                            controlId='SmtpNewInput'
                            label="Smtp"
                            className="mb-2"
                        >
                            <Form.Select
                                value={datosEnvioConfig.smtp}
                                onChange={event => {
                                    setDatosEnvioConfig({ ...datosEnvioConfig, smtp: event.target.value })
                                }}
                            >
                                <option value="">Seleccione</option>
                                {configSmtp.map((item, index) =>
                                    <option key={index} value={item.correosmtpid}>{item.descripcion}</option>
                                )}
                            </Form.Select>
                        </FloatingLabel>
                    </div>
                    <div className='col-md-1'>
                        <Button variant="success" size='sm' type='button' onClick={guardarConfigEnvio}>Guardar</Button>
                    </div>
                </div>
                <br />

                <div className="row">
                    <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom style={{ textAlign: "center" }}>
                                Certificado
                                <Form.Check
                                    style={{ textAlign: 'center', justifyContent: 'center' }}
                                    required
                                    checked={datosEnvioConfig.certificado}
                                    onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, certificado: event.target.checked })}
                                />
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={3}>
                                    <FloatingLabel controlId="certDesdeMsj1NewInput" label="Desde Msj 1">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.certDesdeMsj1}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, certDesdeMsj1: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>

                                    <FloatingLabel controlId="certHastaMsj1NewInput" label="Hasta Msj 1">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.certHastaMsj1}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, certHastaMsj1: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>

                                    <FloatingLabel
                                        controlId='MensajePlantilla1NewInput'
                                        label="Mensaje 1"
                                        className="mb-2"
                                    >
                                        <Form.Select
                                            value={datosEnvioConfig.certMensaje1}
                                            onChange={event => {
                                                setDatosEnvioConfig({ ...datosEnvioConfig, certMensaje1: event.target.value })
                                            }}
                                        >
                                            <option value="">Seleccione</option>
                                            {plantilla.map((item, index) =>
                                                <option key={index} value={item.correoplantillaid}>{item.descripcion}</option>
                                            )}
                                        </Form.Select>
                                    </FloatingLabel>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FloatingLabel controlId="certDesdeMsj2NewInput" label="Desde Msj 2">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.certDesdeMsj2}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, certDesdeMsj2: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>

                                    <FloatingLabel controlId="certHastaMsj2NewInput" label="Hasta Msj 2">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.certHastaMsj2}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, certHastaMsj2: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>

                                    <FloatingLabel
                                        controlId='MensajePlantilla2NewInput'
                                        label="Mensaje 2"
                                        className="mb-2"
                                    >
                                        <Form.Select
                                            value={datosEnvioConfig.certMensaje2}
                                            onChange={event => {
                                                setDatosEnvioConfig({ ...datosEnvioConfig, certMensaje2: event.target.value })
                                            }}
                                        >
                                            <option value="">Seleccione</option>
                                            {plantilla.map((item, index) =>
                                                <option key={index} value={item.correoplantillaid}>{item.descripcion}</option>
                                            )}
                                        </Form.Select>
                                    </FloatingLabel>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FloatingLabel controlId="certDesdeMsj3NewInput" label="Desde Msj 3">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.certDesdeMsj3}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, certDesdeMsj3: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel controlId="certHastaMsj3NewInput" label="Hasta Msj 3">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.certHastaMsj3}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, certHastaMsj3: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel
                                        controlId='MensajePlantilla3NewInput'
                                        label="Mensaje 3"
                                        className="mb-2"
                                    >
                                        <Form.Select
                                            value={datosEnvioConfig.certMensaje3}
                                            onChange={event => {
                                                setDatosEnvioConfig({ ...datosEnvioConfig, certMensaje3: event.target.value })
                                            }}
                                        >
                                            <option value="">Seleccione</option>
                                            {plantilla.map((item, index) =>
                                                <option key={index} value={item.correoplantillaid}>{item.descripcion}</option>
                                            )}
                                        </Form.Select>
                                    </FloatingLabel>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FloatingLabel controlId="certDesdeMsj4NewInput" label="Desde Msj 4">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.certDesdeMsj4}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, certDesdeMsj4: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel controlId="certHastaMsj4NewInput" label="Hasta Msj 4">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.certHastaMsj4}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, certHastaMsj4: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel
                                        controlId='MensajePlantilla4NewInput'
                                        label="Mensaje 4"
                                        className="mb-2"
                                    >
                                        <Form.Select
                                            value={datosEnvioConfig.certMensaje4}
                                            onChange={event => {
                                                setDatosEnvioConfig({ ...datosEnvioConfig, certMensaje4: event.target.value })
                                            }}
                                        >
                                            <option value="">Seleccione</option>
                                            {plantilla.map((item, index) =>
                                                <option key={index} value={item.correoplantillaid}>{item.descripcion}</option>
                                            )}
                                        </Form.Select>
                                    </FloatingLabel>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </div>
                <br />

                <div className="row">
                    <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom style={{ textAlign: "center" }}>
                                Plan x consumo
                                <Form.Check
                                    style={{ textAlign: 'center', justifyContent: 'center' }}
                                    required
                                    checked={datosEnvioConfig.plan}
                                    onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, plan: event.target.checked })}
                                />
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={3}>
                                    <FloatingLabel controlId="planDesdeNewInput" label="Desde Msj 1">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.planDesde}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, planDesde: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>

                                    <FloatingLabel controlId="planHastaNewInput" label="Hasta Msj 1">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.planhasta}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, planhasta: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel
                                        controlId='MensajePlantilla1NewInput'
                                        label="Mensaje 1"
                                        className="mb-2"
                                    >
                                        <Form.Select
                                            value={datosEnvioConfig.planMensaje1}
                                            onChange={event => {
                                                setDatosEnvioConfig({ ...datosEnvioConfig, planMensaje1: event.target.value })
                                            }}
                                        >
                                            <option value="">Seleccione</option>
                                            {plantilla.map((item, index) =>
                                                <option key={index} value={item.correoplantillaid}>{item.descripcion}</option>
                                            )}
                                        </Form.Select>
                                    </FloatingLabel>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FloatingLabel controlId="planDesde2NewInput" label="Desde Msj 2">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.planDesde2}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, planDesde2: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>

                                    <FloatingLabel controlId="planHasta2NewInput" label="Hasta Msj 2">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.planhasta2}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, planhasta2: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel
                                        controlId='MensajePlantilla2NewInput'
                                        label="Mensaje 2"
                                        className="mb-2"
                                    >
                                        <Form.Select
                                            value={datosEnvioConfig.planMensaje2}
                                            onChange={event => {
                                                setDatosEnvioConfig({ ...datosEnvioConfig, planMensaje2: event.target.value })
                                            }}
                                        >
                                            <option value="">Seleccione</option>
                                            {plantilla.map((item, index) =>
                                                <option key={index} value={item.correoplantillaid}>{item.descripcion}</option>
                                            )}
                                        </Form.Select>
                                    </FloatingLabel>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FloatingLabel controlId="planDesde3NewInput" label="Desde Msj 3">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.planDesde3}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, planDesde3: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>

                                    <FloatingLabel controlId="planHasta3NewInput" label="Hasta Msj 3">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.planhasta3}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, planhasta3: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel
                                        controlId='MensajePlantilla3NewInput'
                                        label="Mensaje 3"
                                        className="mb-2"
                                    >
                                        <Form.Select
                                            value={datosEnvioConfig.planMensaje3}
                                            onChange={event => {
                                                setDatosEnvioConfig({ ...datosEnvioConfig, planMensaje3: event.target.value })
                                            }}
                                        >
                                            <option value="">Seleccione</option>
                                            {plantilla.map((item, index) =>
                                                <option key={index} value={item.correoplantillaid}>{item.descripcion}</option>
                                            )}
                                        </Form.Select>
                                    </FloatingLabel>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FloatingLabel controlId="planDesde4NewInput" label="Desde Msj 4">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.planDesde4}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, planDesde4: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>

                                    <FloatingLabel controlId="planHasta4NewInput" label="Hasta Msj 4">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.planhasta4}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, planhasta4: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel
                                        controlId='MensajePlantilla4NewInput'
                                        label="Mensaje 4"
                                        className="mb-2"
                                    >
                                        <Form.Select
                                            value={datosEnvioConfig.planMensaje4}
                                            onChange={event => {
                                                setDatosEnvioConfig({ ...datosEnvioConfig, planMensaje4: event.target.value })
                                            }}
                                        >
                                            <option value="">Seleccione</option>
                                            {plantilla.map((item, index) =>
                                                <option key={index} value={item.correoplantillaid}>{item.descripcion}</option>
                                            )}
                                        </Form.Select>
                                    </FloatingLabel>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </div>

                <br />
                <div className="row">
                    <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
                        <CardContent>
                            <Typography variant="h6" gutterBottom style={{ textAlign: "center" }}>
                                Plan x vencimiento
                                <Form.Check
                                    style={{ textAlign: 'center', justifyContent: 'center' }}
                                    required
                                    checked={datosEnvioConfig.planvenc}
                                    onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, planvenc: event.target.checked })}
                                />
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={3}>
                                    <FloatingLabel controlId="planVencDesdeNewInput" label="Desde Msj 1">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.planVencDesde}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, planVencDesde: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>

                                    <FloatingLabel controlId="planVencHastaNewInput" label="Hasta Msj 1">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.planVenchasta}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, planVenchasta: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel
                                        controlId='MensajePlantillaVenc1NewInput'
                                        label="Mensaje 1"
                                        className="mb-2"
                                    >
                                        <Form.Select
                                            value={datosEnvioConfig.planVencMensaje1}
                                            onChange={event => {
                                                setDatosEnvioConfig({ ...datosEnvioConfig, planVencMensaje1: event.target.value })
                                            }}
                                        >
                                            <option value="">Seleccione</option>
                                            {plantilla.map((item, index) =>
                                                <option key={index} value={item.correoplantillaid}>{item.descripcion}</option>
                                            )}
                                        </Form.Select>
                                    </FloatingLabel>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FloatingLabel controlId="planVencDesde2NewInput" label="Desde Msj 2">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.planVencDesde2}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, planVencDesde2: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>

                                    <FloatingLabel controlId="planVencHasta2NewInput" label="Hasta Msj 2">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.planVenchasta2}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, planVenchasta2: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel
                                        controlId='MensajeVencPlantilla2NewInput'
                                        label="Mensaje 2"
                                        className="mb-2"
                                    >
                                        <Form.Select
                                            value={datosEnvioConfig.planVencMensaje2}
                                            onChange={event => {
                                                setDatosEnvioConfig({ ...datosEnvioConfig, planVencMensaje2: event.target.value })
                                            }}
                                        >
                                            <option value="">Seleccione</option>
                                            {plantilla.map((item, index) =>
                                                <option key={index} value={item.correoplantillaid}>{item.descripcion}</option>
                                            )}
                                        </Form.Select>
                                    </FloatingLabel>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FloatingLabel controlId="planVencDesde3NewInput" label="Desde Msj 3">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.planVencDesde3}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, planVencDesde3: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>

                                    <FloatingLabel controlId="planVencHasta3NewInput" label="Hasta Msj 3">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.planVenchasta3}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, planVenchasta3: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel
                                        controlId='MensajeVencPlantilla3NewInput'
                                        label="Mensaje 3"
                                        className="mb-2"
                                    >
                                        <Form.Select
                                            value={datosEnvioConfig.planVencMensaje3}
                                            onChange={event => {
                                                setDatosEnvioConfig({ ...datosEnvioConfig, planVencMensaje3: event.target.value })
                                            }}
                                        >
                                            <option value="">Seleccione</option>
                                            {plantilla.map((item, index) =>
                                                <option key={index} value={item.correoplantillaid}>{item.descripcion}</option>
                                            )}
                                        </Form.Select>
                                    </FloatingLabel>
                                </Grid>
                                <Grid item xs={12} md={3}>
                                    <FloatingLabel controlId="planVencDesde4NewInput" label="Desde Msj 4">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.planVencDesde4}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, planVencDesde4: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>

                                    <FloatingLabel controlId="planVencHasta4NewInput" label="Hasta Msj 4">
                                        <Form.Control
                                            as="input"
                                            type='number'
                                            rows={1}
                                            autoComplete='off'
                                            value={datosEnvioConfig.planVenchasta4}
                                            onChange={event => setDatosEnvioConfig({ ...datosEnvioConfig, planVenchasta4: event.target.value })}
                                            style={{ marginBottom: 10 }}
                                        />
                                    </FloatingLabel>
                                    <FloatingLabel
                                        controlId='MensajeVencPlantilla4NewInput'
                                        label="Mensaje 4"
                                        className="mb-2"
                                    >
                                        <Form.Select
                                            value={datosEnvioConfig.planVencMensaje4}
                                            onChange={event => {
                                                setDatosEnvioConfig({ ...datosEnvioConfig, planVencMensaje4: event.target.value })
                                            }}
                                        >
                                            <option value="">Seleccione</option>
                                            {plantilla.map((item, index) =>
                                                <option key={index} value={item.correoplantillaid}>{item.descripcion}</option>
                                            )}
                                        </Form.Select>
                                    </FloatingLabel>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </div>
            </Modal.Body>
        </Modal>

    </div>
}

export default Smtp;